// src/core/browserFetch.ts
var browserFetch = typeof window !== "undefined" && typeof fetch !== "undefined" ? async (...args) => await fetch(...args) : null;
var browserFetch_default = browserFetch;
export {
  browserFetch_default as default
};
